import React from 'react';
import { Box, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

/**
 * La riga sopra ogni tabella della sezione: ricerca, filtri, conteggio, azione.
 *
 * Il campo di ricerca usa un `placeholder` e non una `label` fluttuante: nei mockup è un
 * campo con la lente e il testo grigio dentro, e una label che sale sopra il bordo
 * sposterebbe di qualche pixel l'allineamento con le pillole accanto a ogni digitazione.
 */
export default function BarraElenco({
    ricerca,
    onRicerca,
    placeholderRicerca,
    filtri = null,
    conteggio = null,
    azione = null,
}) {
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 2,
            flexWrap: 'wrap',
        }}>
            <TextField
                size="small"
                value={ricerca}
                onChange={(e) => onRicerca(e.target.value)}
                placeholder={placeholderRicerca}
                sx={{ minWidth: 280, flexGrow: { xs: 1, md: 0 } }}
                inputProps={{ 'aria-label': placeholderRicerca }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon fontSize="small" color="disabled" />
                        </InputAdornment>
                    ),
                }}
            />

            {filtri}

            {/* Il divaricatore esiste solo se c'è qualcosa da spingere a destra: senza,
                una barra con la sola ricerca avrebbe un contenitore vuoto che allarga la
                riga e sposta il campo. */}
            {(conteggio || azione) && <Box sx={{ flexGrow: 1 }} />}

            {conteggio && (
                <Box component="span" data-testid="conteggio-elenco"
                     sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
                    {conteggio}
                </Box>
            )}

            {azione}
        </Box>
    );
}
